// @core/api/endpoints/chat/get_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversationResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get conversation details
 * Retrieves conversation metadata including name, type, settings, and member count. Does not include message history.
 */
export async function GetConversation(
  conversation_id: string,
  options?: RequestOptions
): Promise<ConversationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ConversationResponse>(requestPath, { ...requestOptions });
}
